/*
 * VE Variant Manager
 * Handles: combination filtering, selection state, swap recovery, validation, button guard, SKU visibility
 */
(function () {
  'use strict';
  if (window.__VE_loaded) return;
  window.__VE_loaded = true;

  /* ─── PER-SECTION SELECTION STATE ──────────────────────────────── */
  var stateMap = {};
  function getState(sid) {
    if (!stateMap[sid]) stateMap[sid] = {};
    return stateMap[sid];
  }
  function getSectionId(el) {
    var vs = el.closest && el.closest('[data-product-options]');
    return vs ? vs.dataset.section : null;
  }

  /* ─── SEED STATE FROM INITIAL DOM ──────────────────────────────── */
  function seedAllFromDOM() {
    document.querySelectorAll('[data-product-options]').forEach(function (vs) {
      var sid = vs.dataset.section;
      if (!sid) return;
      var state = getState(sid);
      vs.querySelectorAll('[data-popout-input][data-index]').forEach(function (inp) {
        if (inp.value) state[inp.dataset.index] = { value: inp.value, optionValueId: inp.dataset.optionValueId || '', isSwatch: false };
      });
      vs.querySelectorAll('input[type="radio"][data-index]:checked').forEach(function (radio) {
        state[radio.dataset.index] = { value: radio.value, optionValueId: radio.dataset.optionValueId || '', isSwatch: true };
      });
    });
  }

  /* ─── REAPPLY SELECTIONS AFTER DOM SWAP ────────────────────────── */
  function reapplySelections(vs) {
    if (!vs) return;
    var sid = vs.dataset.section;
    if (!sid) return;
    var state = getState(sid);

    // Swatches / radio boxes
    vs.querySelectorAll('.selector-wrapper--swatches').forEach(function (wrapper) {
      var anyRadio = wrapper.querySelector('input[type="radio"][data-index]');
      if (!anyRadio) return;
      var s = state[anyRadio.dataset.index];
      wrapper.querySelectorAll('input[type="radio"]').forEach(function (r) {
        r.checked = !!(s && s.value && r.value === s.value);
      });
    });

    // Dropdowns
    Object.keys(state).forEach(function (optIndex) {
      var s = state[optIndex];
      if (!s || !s.value || s.isSwatch) return;
      var input = vs.querySelector('[data-popout-input][data-index="' + optIndex + '"]');
      if (!input) return;
      input.value = s.value;
      if (s.optionValueId) input.setAttribute('data-option-value-id', s.optionValueId);
      var popout = input.closest('[data-popout-prevent]');
      if (!popout) return;
      var textSpan = popout.querySelector('[data-popout-text]');
      if (textSpan) textSpan.textContent = s.value;
      var list = popout.querySelector('[data-popout-list]');
      if (list) {
        list.querySelectorAll('li').forEach(function (li) {
          var link = li.querySelector('[data-popout-option]');
          li.classList.toggle('select-popout__item--current', !!(link && link.dataset.value === s.value));
        });
      }
    });
  }

  /* ─── FILTER DELETED COMBINATIONS ──────────────────────────────── */
  // Called directly (synchronously) — never deferred — so it always runs on the live element.
  function _doFilterCombinations(vs) {
    if (!vs) return;

    var script = vs.querySelector('[data-all-variants]');
    if (!script) return;

    var allVariants;
    try { allVariants = JSON.parse(script.textContent); }
    catch (e) { return; }
    if (!allVariants || !allVariants.length) return;

    // ── Collect currently selected values (dropdowns + checked radios) ──
    var sel = {}; // key: option 0-based index → string value
    vs.querySelectorAll('[data-popout-input][data-index]').forEach(function (inp) {
      var m = inp.dataset.index.match(/option(\d+)/);
      if (m && inp.value) sel[parseInt(m[1], 10) - 1] = inp.value;
    });
    vs.querySelectorAll('input[type="radio"][data-index]:checked').forEach(function (radio) {
      if (radio.closest('[data-popout-prevent]')) return;
      var m = radio.dataset.index.match(/option(\d+)/);
      if (m) sel[parseInt(m[1], 10) - 1] = radio.value;
    });

    // ── Helper: which values are valid for position `idx`, given all other selections ──
    function validFor(idx) {
      var others = {};
      Object.keys(sel).forEach(function (k) {
        if (parseInt(k, 10) !== idx) others[parseInt(k, 10)] = sel[k];
      });
      var valid = {};
      allVariants.forEach(function (v) {
        var ok = true;
        Object.keys(others).forEach(function (k) {
          if (v.options[parseInt(k, 10)] !== others[parseInt(k, 10)]) ok = false;
        });
        if (ok) valid[v.options[idx]] = true;
      });
      return valid;
    }

    function clearState(stateKey, idx) {
      var sid = vs.dataset.section;
      if (sid) {
        var st = getState(sid);
        if (st[stateKey]) delete st[stateKey];
      }
      delete sel[idx];
    }

    // ── 1. Dropdown / SELECT options ──────────────────────────────────
    vs.querySelectorAll('[data-popout-prevent]').forEach(function (popout) {
      var inp = popout.querySelector('[data-popout-input][data-index]');
      if (!inp) return;
      var m = inp.dataset.index.match(/option(\d+)/);
      if (!m) return;
      var idx = parseInt(m[1], 10) - 1;
      var valid = validFor(idx);

      var list = popout.querySelector('[data-popout-list]');
      if (!list) return;

      var currentHidden = false;
      list.querySelectorAll('.select-popout__item').forEach(function (li) {
        var link = li.querySelector('[data-popout-option]');
        if (!link) return;
        var val = link.dataset.value;
        if (valid[val]) {
          li.style.display = '';
        } else {
          li.style.display = 'none';
          if (inp.value === val) currentHidden = true;
        }
      });

      if (currentHidden) {
        inp.value = '';
        clearState(inp.dataset.index, idx);
        var textSpan = popout.querySelector('[data-popout-text]');
        if (textSpan) {
          var toggle = popout.querySelector('[data-popout-toggle]');
          var labelId = toggle && toggle.getAttribute('aria-labelledby');
          var labelEl = labelId && document.getElementById(labelId);
          textSpan.textContent = 'Select ' + (labelEl ? labelEl.textContent.trim() : '');
        }
        list.querySelectorAll('.select-popout__item--current').forEach(function (el) {
          el.classList.remove('select-popout__item--current');
        });
      }
    });

    // ── 2. Swatch / Radio box options ─────────────────────────────────
    var groups = {}; // idx → [{radio, wrapper}]
    vs.querySelectorAll('input[type="radio"][data-single-option-selector][data-index]').forEach(function (radio) {
      if (radio.closest('[data-popout-prevent]')) return;
      var m = radio.dataset.index.match(/option(\d+)/);
      if (!m) return;
      var idx = parseInt(m[1], 10) - 1;
      var wrapper = radio.closest('.swatch__button') || radio.closest('.radio__button');
      if (!wrapper) return;
      if (!groups[idx]) groups[idx] = [];
      groups[idx].push({ radio: radio, wrapper: wrapper });
    });

    Object.keys(groups).forEach(function (idxStr) {
      var idx = parseInt(idxStr, 10);
      var valid = validFor(idx);
      groups[idxStr].forEach(function (item) {
        if (valid[item.radio.value]) {
          item.wrapper.style.display = '';
        } else {
          item.wrapper.style.display = 'none';
          if (item.radio.checked) {
            item.radio.checked = false;
            clearState(item.radio.dataset.index, idx);
          }
        }
      });
    });
  }

  /* ─── DOM SWAP OBSERVER ─────────────────────────────────────────── */
  function attachSwapObserver() {
    // Persists across callbacks — captures open dropdown from the removed VS,
    // then reopens it on the newly added VS.
    var pendingReopen = {}; // sid → option data-index string

    new MutationObserver(function (mutations) {

      // Pass 1 — capture open dropdown state from REMOVED variant-selects
      // (the element is still accessible in removedNodes even after DOM detachment)
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].removedNodes.length; j++) {
          var node = mutations[i].removedNodes[j];
          if (node.nodeType !== 1) continue;
          var oldVS = node.tagName === 'VARIANT-SELECTS'
            ? node
            : node.querySelector && node.querySelector('variant-selects');
          if (!oldVS) continue;
          var sid = oldVS.dataset.section;
          if (!sid) continue;

          // Primary signal: the visible list class; fallback: aria-expanded
          var openList = oldVS.querySelector('.select-popout__list--visible');
          var openPopout = openList
            ? openList.closest('[data-popout-prevent]')
            : (function () {
                var t = oldVS.querySelector('[data-popout-toggle][aria-expanded="true"]');
                return t ? t.closest('[data-popout-prevent]') : null;
              }());

          if (openPopout) {
            var inp = openPopout.querySelector('[data-popout-input]');
            if (inp && inp.dataset.index) {
              pendingReopen[sid] = inp.dataset.index;
            }
          }
        }
      }

      // Pass 2 — set up newly added variant-selects
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          var newVS = node.tagName === 'VARIANT-SELECTS'
            ? node
            : node.querySelector && node.querySelector('variant-selects');
          if (!newVS) continue;

          var newSid = newVS.dataset.section;

          reapplySelections(newVS);
          _doFilterCombinations(newVS);
          updateSkuVisibility(newVS);

          var reopenIdx = newSid && pendingReopen[newSid];
          if (reopenIdx) {
            delete pendingReopen[newSid];
            (function (idx, el) {
              // setTimeout(0): lets the browser finish upgrading the custom element
              // (popout-select connectedCallback) before we programmatically open it.
              setTimeout(function () {
                var inp2 = el.querySelector('[data-popout-input][data-index="' + idx + '"]');
                var wrap = inp2 && inp2.closest('[data-popout-prevent]');
                var toggle = wrap && wrap.querySelector('[data-popout-toggle]');
                if (toggle) toggle.click();
              }, 0);
            })(reopenIdx, newVS);
          }
        }
      }

    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ─── SAVE SELECTIONS + FILTER ON CHANGE ───────────────────────── */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.dataset || !input.dataset.index) return;
    var sid = getSectionId(input);
    if (!sid) return;
    var state = getState(sid);

    if (input.matches && input.matches('[data-popout-input]')) {
      state[input.dataset.index] = { value: input.value, optionValueId: input.dataset.optionValueId || '', isSwatch: false };
      // Direct synchronous call — runs on the live VS before any DOM swap
      _doFilterCombinations(input.closest('[data-product-options]'));

    } else if (input.type === 'radio' && input.closest('[data-product-options]')) {
      state[input.dataset.index] = { value: input.value, optionValueId: input.dataset.optionValueId || '', isSwatch: true };
      _doFilterCombinations(input.closest('[data-product-options]'));
    }
  });

  /* ─── CLEAR ERRORS ON CHANGE ────────────────────────────────────── */
  document.addEventListener('change', function (e) {
    var w = e.target.closest('[data-selector-wrapper]');
    if (!w) return;
    var err = w.querySelector('[data-option-error]');
    if (err) err.textContent = '';
    w.classList.remove('selector-wrapper--error');
    updateSkuVisibility(w);
  });

  /* ─── KEEP BUTTONS ENABLED ─────────────────────────────────────── */
  function guardButtons() {
    document.querySelectorAll('[data-add-to-cart], #buy-now-btn').forEach(function (btn) {
      if (btn.__veGuarded) return;
      btn.__veGuarded = true;
      new MutationObserver(function () {
        if (btn.disabled) btn.removeAttribute('disabled');
      }).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    });
  }

  /* ─── VALIDATION ────────────────────────────────────────────────── */
  function findVariantSelects(el) {
    if (!el) return null;
    var containers = ['[data-form-wrapper]', 'product-info', '.popup-quick-view__form', '.product__form', 'product-form'];
    for (var i = 0; i < containers.length; i++) {
      var c = el.closest(containers[i]);
      if (c) {
        var vs = c.querySelector('[data-product-options]');
        if (vs) return vs;
      }
    }
    var form = el.closest('form') || el.closest('[data-product-form]');
    if (form) {
      var fw = form.closest('[data-form-wrapper]') || form.closest('product-info') || form.closest('.popup-quick-view__form');
      if (fw) {
        var vs2 = fw.querySelector('[data-product-options]');
        if (vs2) return vs2;
      }
    }
    var popups = document.querySelectorAll('.popup-quick-view__form');
    for (var q = 0; q < popups.length; q++) {
      var qvVs = popups[q].querySelector('[data-product-options]');
      if (qvVs && qvVs.offsetParent !== null) return qvVs;
    }
    return document.querySelector('[data-product-options]');
  }

  function getUnselected(vs) {
    if (!vs) return [];
    var arr = [];
    vs.querySelectorAll('[data-selector-wrapper]').forEach(function (w) {
      if (w.closest('.selector-wrapper--qty')) return;
      var inp = w.querySelector('[data-popout-input]');
      if (inp && !inp.value) { arr.push(w); return; }
      if (w.classList.contains('selector-wrapper--swatches') && !w.querySelector('input:checked')) arr.push(w);
    });
    return arr;
  }

  function showErrors(vs, wrappers) {
    if (!vs) return;
    vs.querySelectorAll('[data-option-error]').forEach(function (el) { el.textContent = ''; });
    vs.querySelectorAll('[data-selector-wrapper]').forEach(function (w) { w.classList.remove('selector-wrapper--error'); });
    wrappers.forEach(function (w) {
      var err = w.querySelector('[data-option-error]');
      if (err) err.textContent = 'Please select ' + (w.dataset.optionName || 'this option');
      w.classList.add('selector-wrapper--error');
    });
    if (wrappers.length) wrappers[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function validate(el, e) {
    var vs = findVariantSelects(el);
    if (!vs) {
      var form2 = el.closest('form') || el;
      var hiddenInput = form2.querySelector('[data-product-select]');
      if (hiddenInput && !hiddenInput.value) { e.preventDefault(); e.stopImmediatePropagation(); return false; }
      return true;
    }
    var unselected = getUnselected(vs);
    if (unselected.length > 0) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showErrors(vs, unselected);
      return false;
    }
    return true;
  }

  /* ─── CLICK / SUBMIT GUARDS ─────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]') || e.target.closest('#buy-now-btn');
    if (btn && !btn.classList.contains('btn-quick-buy')) { validate(btn, e); return; }
    var pay = e.target.closest('[data-buy-it-now] button') || e.target.closest('.shopify-payment-button button');
    if (pay) validate(pay, e);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = (e.target.matches && e.target.matches('[data-product-form]'))
      ? e.target
      : e.target.closest && e.target.closest('[data-product-form]');
    if (!form || form.querySelector('.btn-quick-buy')) return;
    validate(form, e);
  }, true);

  /* ─── SKU VISIBILITY ────────────────────────────────────────────── */
  function updateSkuVisibility(fromEl) {
    var vs = findVariantSelects(fromEl);
    if (!vs) return;
    var pi = vs.closest('product-info') || vs.closest('[data-form-wrapper]') || vs.closest('.popup-quick-view__form');
    if (!pi) return;
    var skuW = pi.querySelector('[data-sku-wrapper]');
    if (!skuW) return;
    if (getUnselected(vs).length === 0) skuW.classList.remove('product__sku--hidden');
    else skuW.classList.add('product__sku--hidden');
  }

  /* ─── INIT ──────────────────────────────────────────────────────── */
  function init() {
    seedAllFromDOM();
    attachSwapObserver();
    guardButtons();
    document.querySelectorAll('[data-product-options]').forEach(function (vs) {
      _doFilterCombinations(vs);
      updateSkuVisibility(vs);
    });
    new MutationObserver(function () { guardButtons(); }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();
